import * as types from '@/store/mutation-types';

const mutations = {
  [types.ADD_ACC_SECTION](state, p) {
    const drp = p.drp;
    drp.sections.push(p.newSec);
  },
  [types.REMOVE_ACC_SECTION](state, p) {
    const drp = p.drp;
    drp.sections.splice(p.secIndex, 1);
  },
  [types.SET_ACC_TITLE](state, p) {
    const section = p.section;
    section.title = p.title;
  },
};

const actions = {
  addNewAccSection: ({ commit }, payload) => {
    commit(types.ADD_ACC_SECTION, payload);
  },
  removeAccSection: ({ commit }, payload) => {
    commit(types.REMOVE_ACC_SECTION, payload);
  },
  async setAccTitle({ dispatch, commit }, payload) {
    await commit(types.SET_ACC_TITLE, payload);
    dispatch('setSiteSave', { status: true, type: 'Droplet' });
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/accordion/vuex.js